import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core/common/event';
let CommentsSelectServiceImp = class CommentsSelectServiceImp {
    constructor() {
        this._allSelectedCommentIds = new Set();
        this._onChangeEmitter = new Emitter();
        this.onChange = this._onChangeEmitter.event;
    }
    clearSelected() {
        this._allSelectedCommentIds.clear();
        this._notifySelectionChange();
    }
    getSelectedComments() {
        return Array.from(this._allSelectedCommentIds);
    }
    selectComments(commentIds) {
        commentIds.forEach(commentId => {
            this._allSelectedCommentIds.add(commentId);
        });
        this._notifySelectionChange();
    }
    deselectComments(commentIds) {
        commentIds.forEach(commentId => {
            this._allSelectedCommentIds.delete(commentId);
        });
        this._notifySelectionChange();
    }
    _notifySelectionChange() {
        this._onChangeEmitter.fire(this.getSelectedComments());
    }
    includes(commentId) {
        return this._allSelectedCommentIds.has(commentId);
    }
};
CommentsSelectServiceImp = __decorate([
    injectable()
], CommentsSelectServiceImp);
export { CommentsSelectServiceImp };
